<template>
    <!--绑定码-->
    <el-dialog
            title="查看绑定码"
            :visible.sync="showState"
            width="420px" class="bind-box"
            :modal="true"
            :modal-append-to-body="true"
            :append-to-body="true"
    >
        <div class="bind-code-box" v-if="bindCodeData.qrcode">
            <div class="center">
                <img class="qrcode" :src="bindCodeData.qrcode" />
            </div>
            <!--<p class="center">-->
            <!--您的绑定码：<span style="color: red">{{bindCodeData.bind_code}}</span>（{{bindCodeData.expire_desc}}）-->
            <!--</p>-->
            <p class="center">
                微信扫码关注即可绑定
                <el-popover placement="top-start" width="200" trigger="hover">
                    绑定后消费可实时提醒<br />
                    还支持消费、充值、余额查询
                    <i class="tips el-icon-info" slot="reference"></i>
                </el-popover>
            </p>
            <p class="center">状态：{{bindCodeData.wechat ? "已绑定" : "未绑定"}}</p>
        </div>
        <div class="bind-code-box" v-else>
            <div class="center">
                <div class="image-slot">
                    <i class="el-icon-loading"></i>&nbsp;&nbsp;绑定码加载中…
                </div>
            </div>
            <p class="center">&nbsp;</p>
            <p class="center">&nbsp;</p>
        </div>

    </el-dialog>
</template>

<script>
    export default {
        name: "StoreUserBindCode",
        model:{
            prop: "bindCodeShow",
            event: "show"
        },
        props:{
            bindCodeShow: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: [String, Number],
                default: ""
            }
        },
        data(){
            return {
                showState: false,
                bindCodeData: {}
            };
        },
        methods: {
            init(){
                this.bindCodeData = {};
                this.loadBindCode();
                this.showState = true;
            },
            loadBindCode(){
                this.$root.postData("cash/get_store_bind_code", {store_uid: this.storeUid}, res => {
                    if(res.errcode === 0){
                        this.bindCodeData = res.data;
                        // if(res.data.expire_time) {
                        //     setTimeout(() => {
                        //         if(this.bindCodeShow) this.loadBindCode();
                        //     }, res.data.expire_time * 1000);
                        // }
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            }
        },
        watch:{
            bindCodeShow(val){
                if(val) this.init();
            },
            showState(val){
                if(!val) this.$emit("show", false);
            }
        }
    }
</script>

<style scoped>
    .bind-code-box .center{
        display: flex;
        justify-content: center;
        text-align: center;
    }
    .bind-code-box .tips{
        color: #cac9c9;
    }

    .bind-code-box .qrcode{
        width: 180px;
        height: 180px;
    }
    .bind-code-box .image-slot{
        width: 180px;
        height: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .bind-code-box .el-icon-loading{
        font-size: 20px;
    }
</style>
<style>
    .bind-box .el-dialog__body{
        padding-top: 10px;
    }
</style>
